import React from 'react';
import './SFCVoteCommentPanel.less';
import { IconFont, SFCAvatar } from '@src/features/common';
import { CommentInfo } from '@src/services';
import { Link } from 'react-router-dom';

export interface ISFCVoteCommentPanelProps {
  type: boolean;
  commonItemInfo: CommentInfo;
  thumbs: (id: number, type: boolean) => void;
}
type Props = ISFCVoteCommentPanelProps;

export function SFCVoteCommentPanel(props: Props) {
  const { type, commonItemInfo } = props;
  return (
    <div className={`common-presenter k-common-vote-comment-panel ${type ? 'red' : 'blue'}`}>
      <div className={`comment-panel__tag`}>
        <span className="comment-panel__tag--desc">{type ? '红方' : '蓝方'}热评</span>
        <IconFont
          type="icon-tag-bar"
          className={`comment-panel__tag--icon ${type ? 'red' : 'blue'} ${
            commonItemInfo ? 'active' : ''
          }`}
        />
      </div>
      {commonItemInfo ? (
        <>
          <div className="comment-panel__info">
            <SFCAvatar
              src={commonItemInfo && commonItemInfo.userInfo && commonItemInfo.userInfo.photo}
              className="comment-panel__info--avatar"
            />
            <Link
              to={`/personal/${commonItemInfo &&
                commonItemInfo.userInfo &&
                commonItemInfo.userInfo.username}`}
            >
              <div className="comment-panel__info--name">
                {commonItemInfo && commonItemInfo.userInfo && commonItemInfo.userInfo.name}
              </div>
            </Link>
          </div>
          <div className="comment-panel__content">{commonItemInfo.comment}</div>
        </>
      ) : (
        <>
          <div className="comment-panel__empty">
            <div className={`comment-panel__empty--icon  ${type ? 'red' : 'blue'}`} />
            <div className={`comment-panel__empty--desc  ${type ? 'red' : 'blue'}`}>
              投票并发表观点，有机会被选为热评哦！
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SFCVoteCommentPanel;
